export default __webpack_public_path__ + "static/media/Cruciatus.3f771c74.jpg";